import { Record } from 'immutable';
import { EMAIL_PREVIOUS_REPLIES } from '../constants/attachmentTypes';
const EmailPreviousReplies = Record({
  '@type': EMAIL_PREVIOUS_REPLIES,
  previousRepliesHtml: null,
  previousRepliesPlainText: null
}, 'EmailPreviousReplies');
export default EmailPreviousReplies;